import store from 'store';
import types from 'store/types/auth';
import actions from 'store/actions/definitions';

export const getUsers = async (queryString) => {
  return store().dispatch(actions.getUsers(queryString));
};
export const getAllUser = async (queryString) => {
  return store().dispatch(actions.getAllUser(queryString));
};
export const addUser = async (data) => {
  return store().dispatch(actions.addUser(data));
};
export const editUser = async (data, id) => {
  return store().dispatch(actions.editUser(data, id));
};
export const deleteUser = async (id) => {
  return store().dispatch(actions.deleteUser(id));
};
export const changeActivateUser = async (data) => {
  return store().dispatch(actions.changeActivateUser(data));
};
export const changeUserStore = async (data) => {
  return store().dispatch(actions.changeUserStore(data));
};
export const getRoles = async () => {
  return store().dispatch(actions.getRoles());
};
export const getStores = async (queryString) => {
  return store().dispatch(actions.getStores(queryString));
};
export const getAllActiveStores = async () => {
  return actions.getAllActiveStores();
};
export const getFirms = async (queryString) => {
  return store().dispatch(actions.getFirms(queryString));
};
export const getFirmPaymentTypes = async () => {
  return store().dispatch(actions.getFirmPaymentTypes());
};
export const getSlotDates = (queryString) => {
  return actions.getSlotDates(queryString);
};
export const deleteFirm = async (id) => {
  return store().dispatch(actions.deleteFirm(id));
};
export const addFirm = async (data) => {
  return store().dispatch(actions.addFirm(data));
};
export const editFirm = async (data, id) => {
  return store().dispatch(actions.editFirm(data, id));
};
export const getRegions = async (queryString) => {
  return store().dispatch(actions.getRegions(queryString));
};
export const getV2Regions = async (queryString) => {
  return actions.getV2Regions(queryString);
};
export const getRegionsWithoutStore = async (directorateId) => {
  return actions.getRegionsWithoutStore(directorateId);
};
export const getDirectorates = async () => {
  return actions.getDirectorates();
};
export const getRegionsByDirectorate = async (directorateId) => {
  return actions.getRegionsByDirectorate(directorateId);
};
export const getStoresByRegion = async (regionId) => {
  return actions.getStoresByRegion(regionId);
};
export const getActiveStores = async (regionId) => {
  return actions.getActiveStores(regionId);
};
export const getAllStoresInRegions = async (data) => {
  return actions.getAllStoresInRegions(data);
};
export const getV2Stores = async (queryString) => {
  return actions.getV2Stores(queryString);
};

export const getV2Zones = async (queryString) => {
  return actions.getV2Zones(queryString);
};
export const getAllZonesInStores = async (data) => {
  return actions.getAllZonesInStores(data);
};
export const deleteRegion = async (id) => {
  return store().dispatch(actions.deleteRegion(id));
};
export const addRegion = async (data) => {
  return store().dispatch(actions.addRegion(data));
};
export const editRegion = async (data, id) => {
  return store().dispatch(actions.editRegion(data, id));
};
export const sendLink = async (data) => {
  return store().dispatch(actions.sendLink(data));
};
export const setActiveRegion = (region) => {
  const user = store().getState().auth.user;
  return store().dispatch({
    type: types.AUTH_SET,
    key: 'user',
    data: { ...user, activeRegion: region },
  });
};
export const editStore = async (data, code) => {
  return actions.editStore(data, code);
};
export const getDownloadLinkForCollector = () => {
  return actions.getDownloadLinkForCollector();
};
export const excelFileUpload = async (data) => {
  return actions.excelFileUpload(data);
};
export const getStoreList = async (queryString) => {
  return actions.getStoreList(queryString);
};
export const getShipmentTypes = async () => {
  return actions.getShipmentTypes();
};
export const getPaymentTypes = async () => {
  return actions.getPaymentTypes();
};
export const getBulkDefinitionsTraces = async (queryString) => {
  return actions.getBulkDefinitionsTraces(queryString);
};
export const getDefinitionTrace = async (traceID) => {
  return actions.getDefinitionTrace(traceID);
};
export const getStoreCategoryRankings = async (payload) => {
  return actions.getStoreCategoryRankings(payload);
};

export const getExcelUrlStoreCategoryRankingTemplate = async () => {
  return actions.getExcelUrlStoreCategoryRankingTemplate();
};

export const getStoreGroups = async (queryString) => {
  return actions.getStoreGroups(queryString);
};

export const getStoresOfStoreGroup = async (regionCode, queryString) => {
  return actions.getStoresOfStoreGroup(regionCode, queryString);
};
export const importStoreInfo = async (data) => {
  return actions.importStoreInfo(data);
};
export const ImportAllZoneUpdate = async (data) => {
  return actions.ImportAllZoneUpdate(data);
};
export const getDownloadLinkForStoreInfo = async () => {
  return actions.getDownloadLinkForStoreInfo();
};
export const getWaitingApproveStores = async (apiParams) => {
  return actions.getWaitingApproveStores(apiParams);
};
export const openForSaleStore = async (storeId) => {
  return actions.openForSaleStore(storeId);
};
export const openForBulkSaleStore = async (storeId) => {
  return actions.openForBulkSaleStore(storeId);
};
export const getCancelledItemHistory = async (queryString) => {
  return actions.getCancelledItemHistory(queryString);
};
export const getOrderHistory = async (queryString) => {
  return actions.getOrderHistory(queryString);
};
export const addStoreManager = async (data) => {
  return store().dispatch(actions.addStoreManager(data));
};
export const downloadTemplateFile = async (code) => {
  return actions.downloadTemplateFile(code);
};
export const addNotificationDefinition = async (data) => {
  return actions.addNotificationDefinition(data);
};
export const deleteNotificationDefinition = async (id) => {
  return actions.deleteNotificationDefinition(id);
};
export const getNotificationDefinitions = async (queryString) => {
  return actions.getNotificationDefinitions(queryString);
};
export const resendNotificationDefinition = async (data) => {
  return actions.resendNotificationDefinition(data);
};
export const getCities = async (queryString) => {
  return actions.getCities(queryString);
};
export const getAllUsers = async (reqBody) => {
  return actions.getAllUsers(reqBody);
};
export const getAllStores = async (reqBody) => {
  return actions.getAllStores(reqBody);
};
export const getAllZones = async (reqBody) => {
  return actions.getAllZones(reqBody);
};
export const getAllRegions = async (reqBody) => {
  return actions.getAllRegions(reqBody);
};
